import styles from "./style.module.scss";
import { Link } from "react-router-dom";

export const AccessSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>
          Access<span>-アクセス-</span>
        </h2>
        <div className={styles.accessBox}>
          <div className={styles.box}>
            <h3>石巻マリンヴィレッジ</h3>
            <p className={styles.postalCode}>
              〒986-0848
              <br />
              宮城県石巻市新館３丁目４−１８
              <br />
              <br />
            </p>
            <p className={styles.tel}>
              TEL&nbsp;<a href="tel:0225903207">0225-90-3207</a>
            </p>
            <p className={styles.accessLink}>
              ※アクセス情報の詳細は
              <Link to="/access" className={styles.link}>
                こちら
              </Link>
              から
            </p>
          </div>
          <iframe
            title="石巻マリンヴィレッジ"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.591674953256!2d141.2626264773537!3d38.42780027182817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f89a30062723d93%3A0x57ec5409f986c52f!2z55-z5be744Oe44Oq44Oz44O044Kj44Os44OD44K4!5e0!3m2!1sja!2sjp!4v1741871705280!5m2!1sja!2sjp"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};
